"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaNetworkListResponseToJSON = exports.RosettaNetworkListResponseFromJSONTyped = exports.RosettaNetworkListResponseFromJSON = void 0;
const _1 = require("./");
function RosettaNetworkListResponseFromJSON(json) {
    return RosettaNetworkListResponseFromJSONTyped(json, false);
}
exports.RosettaNetworkListResponseFromJSON = RosettaNetworkListResponseFromJSON;
function RosettaNetworkListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network_identifiers': (json['network_identifiers'].map(_1.NetworkIdentifierFromJSON)),
    };
}
exports.RosettaNetworkListResponseFromJSONTyped = RosettaNetworkListResponseFromJSONTyped;
function RosettaNetworkListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network_identifiers': (value.network_identifiers.map(_1.NetworkIdentifierToJSON)),
    };
}
exports.RosettaNetworkListResponseToJSON = RosettaNetworkListResponseToJSON;
//# sourceMappingURL=RosettaNetworkListResponse.js.map